export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

type OptionsType = {
  retries?: number,
  delay?: number,
  factor?: number,
};

export async function retryPromise<T>(
  fn: () => Promise<T>,
  { retries = 5, delay = 250, factor = 2 }: OptionsType = {},
) {
  let currentDelay = delay;
  let currentTry = 1;
  let lastError = null;
  while (currentTry <= retries) {
    try {
      // eslint-disable-next-line no-await-in-loop
      const result = await fn();
      return result;
    } catch (err) {
      currentTry += 1;
      currentDelay *= factor;
      lastError = err;
      // eslint-disable-next-line no-await-in-loop
      await wait(currentDelay);
    }
  }
  return Promise.reject(lastError);
}

export function rejectUnlessValue(result: any) {
  return result ? Promise.resolve(result) : Promise.reject(new Error('Value required'));
}
